import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RegistrationModal } from './RegistrationModal';
import { migrateGuestDataToUser } from '../../utils/guestDataMigration';
import { userAuth } from '../../services/userAuth';
import './LoginPage.css';
import './SignupPage.css';

export const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = (location.state as { returnTo?: string })?.returnTo || '/dashboard';

  React.useEffect(() => {
    localStorage.setItem('authReturnTo', returnTo);
  }, [returnTo]);

  const goToSignIn = () => {
    navigate('/login', { state: { returnTo } });
  };

  const handleSuccess = async (user: { id: string }) => {
    await migrateGuestDataToUser(user.id);
    userAuth.refreshUser();
    navigate(returnTo, { replace: true });
  };

  return (
    <div className="login-page-container">
      <button
        type="button"
        className="login-page-back"
        onClick={() => navigate(-1)}
        aria-label="Back to sign in"
      >
        ←
      </button>
      <div className="login-page-card">
        <RegistrationModal
          isOpen
          fullPage
          returnTo={returnTo}
          onClose={goToSignIn}
          onSuccess={handleSuccess}
          onSwitchToSignIn={goToSignIn}
        />
      </div>
    </div>
  );
};
